// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1c8gc","name":"ConsentHeader_name__2Yf-Q","birthday":"ConsentHeader_birthday__aF_Bz","skeleton":"ConsentHeader_skeleton__6a6YH"};